module.exports = __webpack_public_path__ + "img/section3-shadow-right.0a051b53.png";